module.exports = __webpack_public_path__ + "static/media/earthquakes.e39e4ade.png";